import { render, staticRenderFns } from "./About.vue?vue&type=template&id=4d7abecb&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"
import style0 from "./About.vue?vue&type=style&index=0&id=4d7abecb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../Viberary/repos/viberary-frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7abecb",
  null
  
)

export default component.exports